import { SxProps, Theme } from '@mui/material';

export const loginRequestBlockPaperSX = (theme: Theme): SxProps => ({
	background: theme.palette.grey[50],
	borderRadius: '3px',
	p: '10px',
	boxShadow: 'none',
});

export const loginRequestBlockTextSX: SxProps = {
	mb: '15px',
};

export const loginRequestBlockButtonsBoxSX: SxProps = {
	justifyContent: 'space-between',
	flexDirection: 'row',
	display: 'flex',
	width: '100%',
	gap: '10px',
};

export const loginRequestBlockButtonSX: SxProps = {
	flexBasis: 0,
	flexGrow: 1,
	p: '5px',
};
